// This module address a bug in chrome
// https://github.com/bes/scroll-restore-test
// https://goo.gl/TOJRjB

const scrollBody = yPos =>
  setTimeout(() => {
    document.body.scrollTop = yPos;
  }, 0); // force assignment to nextTick

export default browserHistory => {
  if (browserHistory) {
    if (!window.chrome) {
      return;
    }

    browserHistory.scrollRestoration = 'manual';

    browserHistory.listen(
      ({ state, action } = {}) =>
        action === 'POP' && state && scrollBody(state.scrollTop || 0)
    );
  }
};
